import { render } from "./ModalTrophies.vue?vue&type=template&id=3ce94359&scoped=true"
import script from "./ModalTrophies.vue?vue&type=script&lang=js"
export * from "./ModalTrophies.vue?vue&type=script&lang=js"

import "./ModalTrophies.vue?vue&type=style&index=0&id=3ce94359&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ce94359"

export default script